import type { Video } from '@/mocks/videos';

export type RegionFilter = string;
export type YearFilter = string;
export type SortValue = 'latest' | 'hot' | 'rating';

export function getPopularity(video: Video): number {
  return video.rating * 10 + (video.year - 2019) * 0.6;
}

export function sortVideos(list: Video[], sort: SortValue): Video[] {
  const arr = [...list];
  if (sort === 'latest') {
    arr.sort((a, b) => b.addedAt.localeCompare(a.addedAt));
  } else if (sort === 'rating') {
    arr.sort((a, b) => b.rating - a.rating);
  } else {
    arr.sort((a, b) => getPopularity(b) - getPopularity(a));
  }
  return arr;
}

export function filterVideos(
  list: Video[],
  { region, year }: { region: RegionFilter; year: YearFilter }
): Video[] {
  return list.filter((v) => {
    const regionOk = region === '全部' || v.region === region;
    const yearOk = year === '全部' || String(v.year) === year;
    return regionOk && yearOk;
  });
}

export function searchVideos(list: Video[], keyword: string): Video[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return list;
  return list.filter((v) => {
    return (
      v.title.toLowerCase().includes(kw) ||
      v.genre.toLowerCase().includes(kw) ||
      v.region.toLowerCase().includes(kw) ||
      v.categoryLabel.toLowerCase().includes(kw) ||
      v.tags.some((t) => t.toLowerCase().includes(kw)) ||
      v.summary.toLowerCase().includes(kw)
    );
  });
}

export const hotKeywords = ['科幻', '悬疑', '美食', '治愈', '综艺', '古装', '萌宠'];